export default __webpack_public_path__ + "static/media/chet_faker_1.61528634.jpg";